export function FieldSetting(type: any) {
    return (target: any, propertyKey: string | symbol): void => {
        
        Reflect.defineMetadata('fieldSetting:type', type, target, propertyKey);
    };
}